module.exports = __webpack_public_path__ + "img/x-circle.375303e1.svg";